import {
  collection,
  deleteDoc,
  doc,
  FirestoreDataConverter,
  setDoc,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import {
  useCollectionData,
  useDocumentData,
} from 'react-firebase-hooks/firestore';
import { firestore } from '@/lib/firebase';

export interface AlertConfig {
  enabled: boolean;
  recipients: string[];
}

export interface AlertBox {
  ip: string;
  name: string;
  snoozeUntil: Date | null;
}

const configRef = doc(firestore, 'alertConfig', 'global');

export function useAlertConfig() {
  return useDocumentData(configRef);
}

const boxConverter: FirestoreDataConverter<AlertBox> = {
  toFirestore: () => {
    throw new Error('use the mutation helpers');
  },
  fromFirestore: (snapshot) => {
    const d = snapshot.data();
    return {
      ip: d.ip,
      name: d.name,
      snoozeUntil: d.snoozeUntil?.toDate?.() ?? null,
    };
  },
};

export function useAlertBoxes() {
  return useCollectionData(
    collection(firestore, 'alertBoxes').withConverter(boxConverter),
    { snapshotListenOptions: { includeMetadataChanges: false } }
  );
}

export function setMonitoringEnabled(enabled: boolean) {
  return setDoc(configRef, { enabled }, { merge: true });
}

export function setRecipients(recipients: string[]) {
  return setDoc(configRef, { recipients }, { merge: true });
}

export function addAlertBox(ip: string, name: string) {
  return setDoc(doc(firestore, 'alertBoxes', ip), {
    ip,
    name,
    snoozeUntil: null,
  });
}

export function removeAlertBox(ip: string) {
  return deleteDoc(doc(firestore, 'alertBoxes', ip));
}

export function snoozeAlertBox(ip: string, minutes: number) {
  return updateDoc(doc(firestore, 'alertBoxes', ip), {
    snoozeUntil: Timestamp.fromMillis(Date.now() + minutes * 60_000),
  });
}

export function cancelSnooze(ip: string) {
  return updateDoc(doc(firestore, 'alertBoxes', ip), { snoozeUntil: null });
}
